import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

interface ConfirmArchiveProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  hireName: string;
}

const ConfirmArchive: React.FC<ConfirmArchiveProps> = ({
  open,
  onClose,
  onConfirm,
  hireName,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="warning" />
          <Typography variant="h6">Confirm Archive</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to archive <strong>{hireName}</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          This action will move the record to the archive table and remove it from the active hires list.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="warning">
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmArchive; 